import React, { useState, useEffect } from "react";
import moment from "moment";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Breadcrumb } from "@gull";

import BootstrapTable from "react-bootstrap-table-next";
import queryStringService from "app/services/queryStringService";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  getSettlementList,
  exportSettlementList,
} from "app/services/SearchService";

import { Button } from "react-bootstrap";
import { AiFillFileExcel } from "react-icons/ai";
import overlayFactory from "react-bootstrap-table2-overlay";
import _ from "lodash";
import config from "config.json";
import HandyScroll from "app/common/Scroll";
const { dateFormat } = config;

const CreditSettlement = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [SearchUserName, setSearchUserName] = useState("");

  /////

  const dateFormater = (cell, row) => {
    return moment(row.transactionDate).format(dateFormat);
  };

  const transactionModeFormatter = (cell, row) => {
    if (row.transactionMode == "Debit") {
      return (
        <div>
          <span className="text-danger">Debit</span>{" "}
          <img
            src="/assets/images/debit 1.png"
            alt=""
            width={40}
            height={30}
            className="p-0 m-0"
          />
        </div>
      );
    } else {
      return (
        <div>
          <span className="text-success">Credit</span>
          <img
            src="/assets/images/credit 1.png"
            alt=""
            width={40}
            height={30}
            className="p-0 m-0"
          />
        </div>
      );
    }
  };
  const transactionAmountFormatter = (cell, row) => {
    return <span> ₹ {row.deductionAmount} </span>;
  };

  const columns = [
    {
      dataField: "member.memId",
      text: " Sln No.",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", fontSize: "13px", textAlign: "center" };
      },
    },
    {
      dataField: "member.uniqueIdentity",
      text: "User Name",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", fontSize: "13px", textAlign: "center" };
      },
    },

    {
      dataField: "member.company",
      text: "Company",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", fontSize: "13px", textAlign: "center" };
      },
    },

    {
      dataField: "corelationId",
      text: "Correlation Id",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", fontSize: "13px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionMode",
      text: "Trans Mode",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", fontSize: "13px", textAlign: "center" };
      },
      formatter: transactionModeFormatter,
    },
    {
      dataField: "transactionDate",
      text: "Trans Date",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", fontSize: "13px", textAlign: "center" };
      },
      formatter: dateFormater,
    },
    {
      dataField: "transactionType",
      text: "Trans Type",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", fontSize: "13px", textAlign: "center" };
      },
    },
    {
      dataField: "deductionAmount",
      text: "Deduction Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", fontSize: "13px", textAlign: "center" };
      },
      formatter: transactionAmountFormatter,
    },
  ];

  useEffect(() => {
    loadBookingLog();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page, sizePerPage]);

  const loadBookingLog = async () => {
    const query = queryStringService.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate,
      ToDate,
      SearchUserName,
    });

    if (dataCount !== 0) {
      setLoading(true);
    }

    try {
      const response = await getSettlementList(query);

      const responseData = response.data.data;
      const paggingData = JSON.parse(response.headers["x-pagination"]);

      setData(responseData);
      setDataCount(paggingData.TotalCount);
      setPage(paggingData.CurrentPage);
      setSizePerPage(paggingData.PageSize);
      setLoading(false);
    } catch (error) {
      console.error("Error loading booking log:", error);
      setLoading(false);
    }
  };

  const resetTableHandler = async () => {
    const query = queryStringService.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });

    if (dataCount !== 0) {
      setLoading(true);
    }

    try {
      const response = await getSettlementList(query);

      const responseData = response.data.data;
      const paggingData = JSON.parse(response.headers["x-pagination"]);

      setData(responseData);
      setDataCount(paggingData.TotalCount);
      setPage(paggingData.CurrentPage);
      setSizePerPage(paggingData.PageSize);
      setLoading(false);
    } catch (error) {
      console.error("Error loading booking log:", error);
      setLoading(false);
    }
  };

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };
  const refreshFilter = async () => {
    setFromDate("");
    setToDate("");
    setSearchUserName("");

    await resetTableHandler();
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    const currentIndex = (page - 1) * sizePerPage;
    setPage(page);
    setSizePerPage(sizePerPage);
    setTimeout(async () => {
      await loadBookingLog();
    }, 10);
  };

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setTimeout(async () => {
      await loadBookingLog();
    }, 10);
  };

  const handleExport = async () => {
    setPage(1);
    setSizePerPage(10);
    setTimeout(async () => {
      await exportSettlementList();
    }, 10);
  };

  const exportSettlementList = async () => {
    const query = queryStringService.getQueryStringFromObj({
      FromDate,
      ToDate,
      SearchUserName,
    });

    if (dataCount !== 0) {
      setLoading(true);
    }

    try {
      const response = await exportSettlementList(query);
      if (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${moment().toISOString()}_CreditSettlementList.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error exporting settlement list:", error);
      setLoading(false);
    }
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    if (name === "FromDate") setFromDate(value);
    else if (name === "ToDate") setToDate(value);
    else if (name === "SearchUserName") setSearchUserName(value);
  };
  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary h-75" : "btn-light h-75"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <div>
        <Helmet>
          <title>Credit Settlement List</title>
        </Helmet>
        <Breadcrumb
          routeSegments={[{ name: "Credit Settlement List" }]}
        ></Breadcrumb>
        {/* ... rest of your component code ... */}

        <div className=" mx-auto mb-2">
          <div className="bookingList-header">
            <div className="row">
              {/* <div className="col-md-2 col-12 mb-1">
                      <div className="input-group mb-3">
                        <select
                          name="SearchBy"
                          className="form-control"
                          value={this.state.SearchBy}
                          onChange={this.handleSearchChanges}
                        >
                          <option value="Travel">Travel</option>
                          <option value="Booking">Booking</option>
                        </select>
                      </div>
                    </div> */}
              <div className="col-12 col-md-3">
                <div>
                  <div className="form-group">Date From</div>
                  <input
                    type="date"
                    className="form-control"
                    value={FromDate}
                    data-date=""
                    // data-date-format="YYYY-MM-DD"
                    name="FromDate"
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </div>
              </div>
              <div className="col-12 col-md-3">
                <div>
                  <div className="form-group">Date To</div>
                  <input
                    type="date"
                    className="form-control"
                    data-date=""
                    // data-date-format="YYYY-MM-DD"
                    value={ToDate}
                    name="ToDate"
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </div>
              </div>
              <div className="col-12 col-md-2">
                <div>
                  <div className="form-group">Search </div>
                  <input
                    type="text"
                    className="form-control"
                    //placeholder="PNR"
                    value={SearchUserName}
                    name="SearchUserName"
                    onChange={handleSearchChanges}
                  />
                </div>
              </div>

              <div className="col d-flex justify-content-end mb-3"></div>
              <div
                className="col-12 col-md-3 d-flex justify-content-end mb-3"
                style={{ marginTop: "3%" }}
              >
                <button className="btn btn-primary  " onClick={handleSearch}>
                  search
                </button>
                <button
                  className="btn btn-primary mx-1"
                  onClick={refreshFilter}
                >
                  Refresh
                </button>
                <Button
                  variant="outline-primary"
                  //className="ml-2"
                  onClick={handleExport}
                >
                  Export Excel
                  <AiFillFileExcel className=" " />
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* ////////////// */}
        <HandyScroll>
          <div
            class="spacious-container"
            data-handy-scroll
            style={{ overflow: "auto" }}
          >
            <BootstrapTable
              hover
              remote
              keyField="sln"
              data={data}
              columns={columns}
              pagination={dataCount > 0 && paginationFactory(paginationOptions)}
              onTableChange={handleTableChange}
              noDataIndication={() => <NoDataIndication />}
              loading={loading}
              // overlay={overlayFactory({
              //   spinner: true,
              //   styles: {
              //     overlay: (base) => ({
              //       ...base,
              //       background: "rgba(120, 120, 120, 0.5)",
              //       zIndex: "1",
              //     }),
              //   },
              // })}
              headerClasses="bg-primary text-white"
              bodyClasses="react-bootstrap-table-next-min-height"
              rowStyle={rowStyle}
            />
          </div>
        </HandyScroll>
      </div>
    </>
  );
};

export default CreditSettlement;
